import { isoToBrDate } from '@/lib/format'
import type { TreatmentPlanProduct } from './api'

/**
 * As linhas prontas do plano de tratamento no portal (RN-POR-23), no vocabulário da paciente.
 */

export const NO_PDF = 'A cópia deste plano está com a clínica.'

export const PDF_NOTE =
  'Este plano foi encerrado pela clínica e é o registro do que foi aplicado em você. O PDF é protegido: permite ler e imprimir, não copiar o texto.'

/** "Allergan · lote VB24A031 · validade 31/03/2027 · Lábio superior, Lábio inferior". */
export function productLine(p: TreatmentPlanProduct): string {
  return [
    p.manufacturer,
    p.lotNumber ? `lote ${p.lotNumber}` : 'lote não informado',
    p.expiryDate ? `validade ${isoToBrDate(p.expiryDate)}` : null,
    p.regions.length > 0 ? p.regions.join(', ') : null,
  ]
    .filter(Boolean)
    .join(' · ')
}

/** "3 fotos"; sem foto, a mesma frase do PDF do plano. */
export function photoCountText(n: number): string {
  if (n === 0) return 'Sem foto registrada nesta etapa'
  return `${n} ${n === 1 ? 'foto' : 'fotos'}`
}
